enum IntegrationService {
  HUBSPOT = "hubspot",
  SALESFORCE = "salesforce",
  ZOHO = "zoho",
  DYNAMICS = "dynamics",
  NETSUITE = "netsuite",
}

export default IntegrationService;
